import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-reset-success',
  templateUrl: './reset-success.component.html',
  styleUrls: ['./reset-success.component.scss']
})
export class ResetSuccessComponent implements OnInit {

  bookId:any;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    this.bookId=data;
   }

  ngOnInit(): void {
  }
}
